import React, {useEffect, useRef} from 'react';
import {
	useAuthToken,
	useClaims,
	useUser,
} from '@deezer/next/contexts/main/hooks';
import {useRouter} from 'next/router';
import {getRouteOnLogin} from './utils';

type RequireUnloggedProps = {
	children: React.ReactNode;
};

const RequireUnlogged = ({children}: RequireUnloggedProps) => {
	const router = useRouter();
	const user = useUser();
	const claims = useClaims();
	const authToken = useAuthToken();
	const isFirstRun = useRef(true);

	useEffect(() => {
		if (isFirstRun.current) {
			if (authToken && user) {
				router.replace(getRouteOnLogin(user, claims));
			}
			isFirstRun.current = false;
		}
	}, [authToken, user, router, claims]);

	return <>{children}</>;
};

export default RequireUnlogged;
